export default {
  apiKey: "AIzaSyCcvAvUjPgIcZY0mP2Qp2DrlelicgWxkhc",
  authDomain: "ayun-kooler.firebaseapp.com",
  projectId: "ayun-kooler",
  storageBucket: "ayun-kooler.firebasestorage.app",
  messagingSenderId: "820436797786",
  appId: "1:820436797786:web:ce40f08f612422f75e0b63",
  measurementId: "G-MGPGSG3Z2V"
};